var render, staticRenderFns
import script from "./GhostButton.vue?vue&type=script&lang=ts&"
export * from "./GhostButton.vue?vue&type=script&lang=ts&"
import style0 from "./GhostButton.vue?vue&type=style&index=0&id=5b098fc1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b098fc1",
  null
  
)

export default component.exports